import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FileUploadService } from 'src/app/main/services/FileUploadService ';

@Component({
  selector: 'app-upload-app-logo',
  templateUrl: './upload-app-logo.component.html',
  styleUrls: ['./upload-app-logo.component.css']
})
export class UploadAppLogoComponent implements OnInit {

  uploadForm: FormGroup;
  fileToUpload: File = null;
  imageError: string = '';
  constructor(private fileUploadService:FileUploadService,private fb: FormBuilder,private activeModal: NgbActiveModal, private toastr: ToastrService) {
    this.uploadForm = this.fb.group({
      file: [null]
    });
   }

  ngOnInit(): void {
  }

  onFileChange(event) {
    this.imageError = '';
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const img = new Image();
      img.onload = () => {
        if (img.width > 80 || img.height > 80) {
          this.imageError = `Image dimensions must be 80x80 pixels or smaller. Current size: ${img.width}x${img.height}.`;
          this.toastr.error(this.imageError, 'Validation Error');
          this.fileToUpload = null;
          this.uploadForm.patchValue({ file: null });
          event.target.value = '';
        } else {
          this.fileToUpload = file;
          this.uploadForm.patchValue({ file: this.fileToUpload });
        }
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(file);
    }
  }

  
closeModal(): void {
    this.activeModal.dismiss(); // Close the modal using NgbActiveModal
  }

  onSubmit() {
    if (!this.fileToUpload) {
      this.toastr.error('Please select a valid image file (max 80x80 pixels).', 'Validation Error');
      return;
    }
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('file').value);

    this.fileUploadService.uploadlogo(formData)
      .subscribe(
        response => {
          this.toastr.success('Logo uploaded successfully!', 'Success');
          this.activeModal.close(response);
        },
        error => {
          this.toastr.error('Failed to upload logo. Please try again.', 'Error');
        }
      );
  }

}
